import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Report.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { ReportDropOffEntity } from "../../entities/ReportEnity";
import { ReportService } from "../../services/report";
import FilterUtils from "../../utils/filter-utils";
import { LuImage } from "react-icons/lu";
import { VendorDropoffService } from "../../services/vendors_dropoff";
import { LogEntity } from "../../entities/LogEntity";
import { LogService } from "../../services/logs";

export default function ReportDropOff() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //

    const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});
    const [tableData, setTableData] = useState<LogEntity[]>([]);
    const [filterDate, setFilterDate] = useState({
        start_date: format(new Date(), "yyyy-MM-dd"),
        end_date: format(new Date(), "yyyy-MM-dd")
    });

    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await LogService.GetAllLogs(filterDate.start_date, filterDate.end_date);
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Report Error Logs"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>Start Date :</label>
                                    <input style={{ fontSize: "12px" }} type="date" value={filterDate.start_date}
                                        onChange={(event) => setFilterDate(prevState => ({
                                            ...prevState,
                                            start_date: event.target.value
                                        }))}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>End Date :</label>
                                    <input style={{ fontSize: "12px" }} type="date" value={filterDate.end_date}
                                        onChange={(event) => setFilterDate(prevState => ({
                                            ...prevState,
                                            end_date: event.target.value
                                        }))}
                                    />
                                </div>
                                <div>
                                    <div style={{ color: "white", textAlign: "left" }}>&nbsp;</div>
                                    <button className="cardButton" onClick={() => generateData()} >
                                        Refresh
                                    </button>
                                </div>
                            </div>
                            <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>tanggal :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.date ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, date: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>request :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.request ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, request: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>response :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.response ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, response: event.target.value }));
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    }
                />
                <div
                    style={{ height: "65vh", overflow: "auto" }}>
                    <table className="tableclickcell">
                        {tableData.length > 0 ?
                            <>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Tanggal</th>
                                        <th>Request</th>
                                        <th>Response</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.filter((row) => {
                                        return FilterUtils.FilterTable(row, tableDataFilter)
                                    }).map((row, idx) => {
                                        return <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{format(row.date, "yyyy-MM-dd HH:mm:ss")}</td>
                                            <td>{row.request}</td>
                                            <td>{row.response}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead><tr><th>no data available yet!</th></tr></thead>
                            </>
                        }
                    </table>
                </div>

            </div>
        </>
    );
}
